import React from 'react';
import { colors } from 'stylesheets';
import {
  TextCustom,
} from '../styles';
import {
  ContainerPhotos,
  WrapperPhotos,
  PhotoWrapper,
  Photo,
} from './styles';

const SectionPhotos = ({ photos }) => (
  <ContainerPhotos>
    <TextCustom size="18px" bold color="#F07E31">Fotos anexadas:</TextCustom>
    <WrapperPhotos>
      {
          photos && photos.map(photo => (photo && (
            <PhotoWrapper aspectRatio={photo.width / photo.height} height="159" key={`pro-${photo.id}`}>
              <Photo
                cache={false}
                source={
                  process.env.NODE_ENV === 'production'
                    ? `${photo.url}?noCache=${Math.random().toString()}`
                    : `${photo.url.replace(/^https:\/\//i, 'http://')}?noCache=${Math.random().toString()}`
                }
              />
            </PhotoWrapper>
          )))
        }
    </WrapperPhotos>
  </ContainerPhotos>
);

export default SectionPhotos;
